<template>
	<div ref="screenshot" class="screenshot">
		<div
			class="image"
			:style="{
				width: imageWidth,
				height: imageHeight,
			}"
		>
			<transition name="component-fade-screenshots" mode="out-in">
				<img v-if="!selectedScreenshot" src="../../assets/images/screenshot-fallback.svg" />
				<img v-else-if="!campaign.is_mobile" :src="getScreenshotUrl(screenshotUrl)" />
				<div v-else-if="campaign.is_mobile" class="mobile-preview">
					<img :src="screenshotUrl" :class="campaign.type" />
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		campaign: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			imageWidth: '100%',
			imageHeight: 'auto',
		};
	},
	computed: {
		selectedScreenshot() {
			const view = this.campaign?.dashboard_default_view || '';

			return this.campaign?.screenshot_urls?.[view] || '';
		},
		screenshotUrl() {
			return this.selectedScreenshot ? this.$urls.cdn(this.selectedScreenshot) : '';
		},
	},
	watch: {
		campaign() {
			this.resetCampaignNumbers();
			this.getScreenshotImageDimensions();
		},
	},
	mounted() {
		this.getScreenshotImageDimensions();
		window.addEventListener('resize', this.resizeScreenshot);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resizeScreenshot);
	},
	methods: {
		getScreenshotImageDimensions() {
			setTimeout(() => {
				if (this.$refs.screenshot && this.selectedScreenshot) {
					const maxWidth =
						'Slide-in' === this.campaign.type || this.campaign.is_mobile
							? '300'
							: this.$refs.screenshot.offsetWidth;
					let img = new Image();
					img.onload = () => {
						const height = this.campaign.is_mobile ? 70 : 0;
						this.imageWidth = maxWidth + 'px';
						this.imageHeight =
							(this.campaign.is_mobile ? 644 : Math.round((img.height * maxWidth) / img.width) + height) +
							'px';
					};
					img.src = this.$urls.cdn(this.getScreenshotUrl(this.selectedScreenshot));
				}
			}, 300);
		},
		getScreenshotUrl(url) {
			return `${url}?ver=${this.$moment(this.campaign.updated, 'YYYY-MM-DD HH:mm:ss').unix()}`;
		},
		resizeScreenshot() {
			return this.getScreenshotImageDimensions(0);
		},
		resetCampaignNumbers() {
			this.setView = null;
			this.imageWidth = '100%';
			this.imageHeight = 'auto';
		},
	},
};
</script>

<style lang="scss">
@import '../../assets/scss/variables';
.content {
	.screenshot {
		margin: 20px 0;

		.image {
			text-align: center;
			margin-bottom: 20px;
			transition: height 0.3s ease;
			overflow: hidden;
			margin: 0 auto;

			img {
				width: 100%;
				height: auto;
			}

			.mobile-preview {
				width: 300px;
				height: 644px;
				margin: 0 auto;
				background: #fff;
				border-top: 50px solid #41495b;
				border-bottom: 50px solid #41495b;
				border-left: 10px solid #41495b;
				border-right: 10px solid #41495b;
				border-radius: 10px;
				display: flex;

				img {
					display: inherit;
				}
			}
		}
	}
}
</style>
